import { Controller } from "stimulus"

export default class extends Controller {
  static values = {
    id: String,
  }

  click(e) {
    e.preventDefault()

    if (typeof window.openAfishaSessionWidget === 'function') {
      window.openAfishaSessionWidget(this.idValue, '')
    }
  }
}
